// extracted by mini-css-extract-plugin
module.exports = {"controls":"_2GsJkg","soloBtn":"lac65e","content":"_1sx8H-"};